import { ITag } from "../types/Tag";

export const filterTag = (query: string, tag: ITag) =>
  tag.label.toLowerCase().includes(query.toLowerCase());

export const areTagsEqual = (a: ITag, b: ITag) => a.id === b.id;

export const renderTag = (tag: ITag) => tag.label;

export function sortTagsAlphabetically(tags: ITag[]): ITag[] {
  return [...tags].sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: "base" })
  );
}

